import { useTranslation } from 'react-i18next';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _every from 'lodash/every';
import SelectPanel from '@lib/components/SelectPanel/SelectPanel';
import { GetLoadOptions } from '@lib/components/Select/types';
import { getOptionsArrayValidation } from '@lib/utils/validationUtils';
import { FieldItem, Values } from '@lib/interfaces/form';
import formStyles from '@lib/assets/styles/Form.module.scss';
import { materialSymbolsOutlined } from '@lib/enums/common';
import Button, {
  ButtonSizes,
  ButtonTypes,
} from '@lib/components/Button/Button';
import { FieldNames } from '../enums';

export default function useFilterFields({
  getFormCategoriesLoadOptions,
  clearFilter,
}: {
  getFormCategoriesLoadOptions: GetLoadOptions;
  clearFilter: () => void;
}): FieldItem[] {
  const { t } = useTranslation();
  return [
    {
      name: FieldNames.FormCategories,
      label: t('form-category'),
      element: SelectPanel,
      validation: getOptionsArrayValidation({ t }),
      formItemClassName: formStyles.formColumnAuto,
      hideErrorsSpace: true,
      componentProps: {
        defaultOptions: false,
        getLoadOptions: getFormCategoriesLoadOptions,
        isAsync: true,
        isMulti: true,
        showTabs: true,
        buttonProps: {
          leftIcon: 'category',
          leftIconClassName: materialSymbolsOutlined,
        },
      },
      isOptionalFn: () => false,
    },
    {
      name: FieldNames.Reset,
      label: '',
      customRender: () => (
        <Button
          buttonSize={ButtonSizes.large}
          buttonText={t('reset')}
          buttonType={ButtonTypes.primaryText}
          onClick={clearFilter}
        />
      ),
      formItemClassName: formStyles.formColumnAuto,
      hideErrorsSpace: true,
      isOptionalFn: () => true,
      isVisibleFn: (values: Values) => {
        const formCategories = _get(values, FieldNames.FormCategories, []);
        return !_every([formCategories], _isEmpty);
      },
    },
  ];
}

export { FieldNames } from '../enums';
